import {reactive} from 'vue'
import CallApi from '../utils/CallApi'
import {store} from '@/vuex'

// // console.log(config);

const auth = () => {
  const AUTH_PREFIX = '/auth'

  const login = async (email: string, password: string) => {
    const state = reactive<{error: any; token: string; user: any}>({
      error: null,
      token: '',
      user: null,
    })
    try {
      const res: any = await CallApi({
        data: {
          email: email,
          password: password,
        },
        method: 'post',
        url: `${AUTH_PREFIX}/login`,
      })

      if (res.token) {
        state.user = res.userInfo
        state.token = res.token
      }
    } catch (error) {
      state.error = error
    }
    return state
  }

  const simplePasswordLogin = async (uuid: string, password: string) => {
    const state = reactive<{error: any; token: string; user: any}>({
      error: null,
      token: '',
      user: null,
    })
    try {
      const result: any = await CallApi({
        data: {
          password: password,
          uuid: uuid,
        },
        method: 'post',
        url: `${AUTH_PREFIX}/simple-password-login`,
      })

      if (result.token) {
        state.user = result.userInfo
        state.token = result.token
      }
    } catch (error) {
      state.error = error
    }
    return state
  }
  
  const superLogin = async (uuid: string, password: string) => {
    const state = reactive<{error: any; token: string; user: any}>({
      error: null,
      token: '',
      user: null,
    })
    try {
      const result: any = await CallApi({
        data: {
          password: password,
          uuid: uuid,
        },
        method: 'post',
        url: `${AUTH_PREFIX}/super-login`,
      })
      
      if (result.token) {
        state.user = result.userInfo
        state.token = result.token
      }
    } catch (error) {
      state.error = error
    }
    return state
  }
  
  const refreshToken = async () => {
    await CallApi({
      method: 'get',
      url: `${AUTH_PREFIX}/refresh-token`,
    })
  }

  const simplePasswordRegist = async (uuid: string, password: string) => {
    let result: any = null
    try {
      result = await CallApi({
        data: {password, uuid},
        method: 'post',
        url: `${AUTH_PREFIX}/simple-password`,
      })
    } catch {
      // console.log(error);
    }
    return result
  }

  const lookupUuid = async (name: string, phone: string, birthDate: string) => {
    const state = reactive<{error: any; uuid: string; simple_password_flag: boolean}>({
      error: null,
      uuid: '',
      simple_password_flag: false,
    })
    try {
      const result: any = await CallApi({
        data: {
          name: name,
          phone: phone,
          birthdate: birthDate,
        },
        method: 'post',
        url: `${AUTH_PREFIX}/lookup-uuid`,
      })

      if (result.uuid) {
        state.uuid = result.uuid
        state.simple_password_flag = result.simple_password_flag
      }
    } catch (error) {
      state.error = error
    }
    return state
  }

  const resetSimplePassword = async (uuid: string, password: string) => {
    let result: any = null
    try {
      result = await CallApi({
        data: {
          uuid: uuid,
          password: password,
        },
        method: 'post',
        url: `${AUTH_PREFIX}/reset-simple-password`,
      })
    } catch (error) {
      // console.log(error);
    }
    return result
  }

  const simplePasswordReset = async (uuid: string) => {
    let result: any = null
    try {
      result = await CallApi({
        data: {uuid},
        method: 'post',
        url: `${AUTH_PREFIX}/simple-password-reset`,
      })
    } catch (error) {
      // console.log(error);
    }
    return result
  }


  const sendVerificationSms = async (phone: string) => {
    let result: any = null
    try {
      result = await CallApi({
        data: {phone},
        method: 'post',
        url: `${AUTH_PREFIX}/send-verification-sms`,
      })
    } catch (error) {
      // console.log(error)
    }
    return result
  }

  const verifySms = async (phone: string, code: string) => {
    const state = reactive<{error: any; verified: boolean}>({
      error: null,
      verified: false,
    })
    try {
      const result: any = await CallApi({
        data: {code, phone},
        method: 'post',
        url: `${AUTH_PREFIX}/verify-sms`,
      })
      state.verified = result.verified
    } catch (error) {
      state.error = error
    }
    return state
  }

  return {
    login,
    lookupUuid,
    refreshToken,
    resetSimplePassword,
    sendVerificationSms,
    simplePasswordLogin,
    simplePasswordRegist,
    simplePasswordReset,
    superLogin,
    verifySms,
  }
}

export default auth
